// Minimal chat store — Phase 2 only needs a handoff slot so Practices can push
// a "/practice <id>" command into the chat input before navigating there.
// Phase 3 (messaging + WebSocket) expands this with messages, loading, etc.

import { create } from 'zustand'

interface ChatStoreState {
  pendingInput: string | null
  pendingDisplay: string | null
  queueInput: (input: string, display?: string | null) => void
  consumeInput: () => { pendingInput: string | null; pendingDisplay: string | null }
  autoOpenChatwoot: boolean
  requestChatwootOpen: () => void
  consumeChatwootOpen: () => boolean
}

export const useChatStore = create<ChatStoreState>()((set, get) => ({
  // A command/text queued by another screen (e.g. Practices) for the chat input.
  pendingInput: null,
  // Optional label shown instead of the raw command (old _displayOverride).
  pendingDisplay: null,

  queueInput: (input, display = null) => set({ pendingInput: input, pendingDisplay: display }),
  consumeInput: () => {
    const { pendingInput, pendingDisplay } = get()
    set({ pendingInput: null, pendingDisplay: null })
    return { pendingInput, pendingDisplay }
  },

  // Set by the payment-return handler after a paid session so the Psychologist
  // screen auto-opens the Chatwoot widget on mount (original openPsychologistChat).
  autoOpenChatwoot: false,
  requestChatwootOpen: () => set({ autoOpenChatwoot: true }),
  consumeChatwootOpen: () => {
    const on = get().autoOpenChatwoot
    if (on) set({ autoOpenChatwoot: false })
    return on
  },
}))
